import { createFileRoute } from '@tanstack/react-router';

import { KontrahenciView } from '../../raporty/projekty/KontrahenciView';

export const Route = createFileRoute('/raporty/kontrahenci-projektow')({
  component: KontrahenciView,
});
